module.exports = __webpack_public_path__ + "static/duca-logo-eacf63de709ca81733ea6c44b6bb36e7.jpeg";